import React, { useEffect, useState } from 'react';

const navLinks = [
  { href: '#projects', label: 'Projects' },
  { href: '#experience', label: 'Experience' },
  { href: '#skills', label: 'Skills' },
  { href: '#education', label: 'Education' },
  { href: '#languages', label: 'Languages' },
  { href: '#activities', label: 'Activities' },
  { href: '#cv', label: 'CV' },
];

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const toggleMenu = () => setIsOpen((prev) => !prev);
  const closeMenu = () => setIsOpen(false);

  return (
    <header
      className={`fixed top-0 left-0 z-50 w-full transition-colors duration-300 ${
        scrolled ? 'bg-[#0a0a0a]/75 backdrop-blur-xl' : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-5 md:px-10">
        {/* Logo */}
        <a href="#home" className="flex items-center no-underline shrink-0">
          <span className="text-[15px] font-medium tracking-tight text-white">
            Helin Akdoğan
          </span>
        </a>

        {/* Desktop menu */}
        <div className="hidden items-center md:flex md:gap-7 lg:gap-9">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="group relative text-[13.5px] font-medium text-neutral-400 no-underline transition-colors hover:text-white"
            >
              {link.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-white transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </div>

        <a
          href="#contact"
          className="hidden rounded-full bg-white px-5 py-2.5 text-[13.5px] font-semibold text-black no-underline transition hover:bg-white/90 md:inline-flex"
        >
          Contact
        </a>

        {/* Mobile menu button */}
        <button
          type="button"
          onClick={toggleMenu}
          aria-label="Toggle menu"
          className="flex h-9 w-9 flex-col items-center justify-center gap-[5px] md:hidden"
        >
          <span
            className={`block h-px w-5 bg-white transition-transform duration-300 ${
              isOpen ? 'translate-y-[3px] rotate-45' : ''
            }`}
          />
          <span
            className={`block h-px w-5 bg-white transition-transform duration-300 ${
              isOpen ? '-translate-y-[3px] -rotate-45' : ''
            }`}
          />
        </button>
      </nav>

      {/* Mobile full-screen overlay */}
      <div
        className={`fixed inset-0 z-40 flex flex-col justify-center bg-[#0a0a0a] px-8 transition-opacity duration-300 md:hidden ${
          isOpen ? 'pointer-events-auto opacity-100' : 'pointer-events-none opacity-0'
        }`}
      >
        <div className="flex flex-col gap-1">
          {navLinks.concat({ href: '#contact', label: 'Contact' }).map((link, i) => (
            <a
              key={link.href}
              href={link.href}
              onClick={closeMenu}
              className="py-3 text-4xl font-semibold tracking-tight text-neutral-300 no-underline transition-colors hover:text-white"
              style={{ transitionDelay: `${i * 20}ms` }}
            >
              {link.label}
            </a>
          ))}
        </div>
      </div>
    </header>
  );
};

export default Header;
